import React, { useCallback } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

import {
  ASSISTED_LIVE_STATUS_TABS,
  setCurrentPage,
} from 'features/assetManagement';
import ElementSpacePlaceholder from 'components/ElementSpacePlaceholder';
import styles from './ASLToolPage.module.scss';

function ASLToolPage() {
  const dispatch = useDispatch();

  const handleTabClick = useCallback(() => {
    dispatch(setCurrentPage(1));
  }, [dispatch]);

  return (
    <>
      <ElementSpacePlaceholder elementId="bulk-upload-project-management" />
      <div className={styles.root}>
        <div className={styles.tabs}>
          {ASSISTED_LIVE_STATUS_TABS.map((tab, tabIndex) => (
            <NavLink
              key={tab.name}
              to={`/asset-management/bulk-upload-video/${tab.to}`}
              tabIndex={tabIndex}
              onClick={handleTabClick}
              className={({ isActive }) =>
                classNames(styles.tab, { [styles.tabActive]: isActive })
              }
            >
              {tab.name}
            </NavLink>
          ))}
        </div>
      </div>
      <Outlet />
    </>
  );
}

export default ASLToolPage;
